import React from 'react';

import ToggleItem from '../../../modules/toggle-item/toggle-item';
import { SORT_DIRECTION } from '../../../types';

import './order-detailed-sorts.scss';

interface OrderDetailedFiltersProps {
  onItemToggle: (
    name: 'positions' | 'sum' | 'count',
    direction: SORT_DIRECTION
  ) => void;
  directions: {
    positions: SORT_DIRECTION;
    count: SORT_DIRECTION;
    sum: SORT_DIRECTION;
  };
}

const OrderDetailedSorts: React.FC<OrderDetailedFiltersProps> = ({
  onItemToggle,
  directions,
}) => (
  <div className="order__sort">
    <div className="order__sort-item">
      <ToggleItem title="Реализации" />
    </div>
    <div className="order__sort-item">
      <ToggleItem
        title="Количество"
        toggle
        direction={directions.positions}
        onChangeToggle={(direction) => onItemToggle('positions', direction)}
      />
    </div>
    <div className="order__sort-item">
      <ToggleItem
        title="Позиций"
        toggle
        direction={directions.count}
        onChangeToggle={(direction) => onItemToggle('count', direction)}
      />
    </div>
    <div className="order__sort-item">
      <ToggleItem
        title="Сумма"
        toggle
        direction={directions.sum}
        onChangeToggle={(direction) => onItemToggle('sum', direction)}
      />
    </div>
  </div>
);

export default OrderDetailedSorts;
